export const API_LINKS = {
  baseUrl: import.meta.env.VITE_BACKEND_ENDPOINT ?? "/",
  logout: `${import.meta.env.VITE_BACKEND_ENDPOINT}/Authentication/Logout`,
};
